import React from "react";
import { useNavigate } from "react-router-dom";

const HeaderTab = ({ params }) => {
  //  console.log("params", params)
  const Navigate = useNavigate();
  const handleActiveCard = (cardName) => {
    Navigate(cardName);
  };
  return (
    <div className="radio-inputs" style={{ marginTop: "-10px" }}>
      <label className="radio">
        <div onClick={() => handleActiveCard("/onboarding/farmers-group/CBBO")}>
          <input
            type="radio"
            name="radio"
            checked={params === "CBBO" ? true : false}
          />
          <span
            className={`name ${
              params === "CBBO" ? "fw-bold text-primary" : "fw-bold"
            }`}
          >
            CBBO
          </span>
        </div>
      </label>
      <label className="radio">
        <div onClick={() => handleActiveCard("/onboarding/farmers-group/FPO")}>
          <input
            type="radio"
            name="radio"
            checked={params === "FPO" ? true : false}
          />
          <span
            className={`name ${
              params === "FPO" ? "fw-bold text-primary" : "fw-bold"
            }`}
          >
            FPO
          </span>
        </div>
      </label>

      <label className="radio">
        <div onClick={() => handleActiveCard("/onboarding/farmers-group/FPC")}>
          <input
            type="radio"
            name="radio"
            checked={params === "FPC" ? true : false}
          />
          <span
            className={`name ${
              params === "FPC" ? "fw-bold text-primary" : "fw-bold"
            }`}
          >
            FPC
          </span>
        </div>
      </label>
      <label className="radio">
        <div
          onClick={() =>
            handleActiveCard("/onboarding/farmers-group/co-operative")
          }
        >
          <input
            type="radio"
            name="radio"
            checked={params === "Co-Operative" ? true : false}
          />
          <span
            className={`name ${
              params === "Co-Operative" ? "fw-bold text-primary" : "fw-bold"
            }`}
          >
            Co-Operative
          </span>
        </div>
      </label>
    </div>
  );
};

export default HeaderTab;
